module.exports = __webpack_public_path__ + "media/flags/003-switzerland-e7f4904b.svg";